//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
    props: {
        blok: {
            type: Object
        }
    },
    computed: {
        ...mapState(['product', 'options']),
    },
    methods: {
        getImage() {
            let image = ''
            if (this.product.data && this.product.data.images) {
                this.product.data.images.map(i => {
                    if (i.groupname == this.blok.imagename) {
                        image = this.product.data.imagepath + i.filename
                    }
                })
            }
            return image
        },
        titleCase(str) {
            return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())
        }
    }
}
